import template from './log.html';
import controller from './log.controller';
import './log.scss';

let logComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default logComponent;


// WEBPACK FOOTER //
// ./client/app/components/log/log.component.js